import { Dashboard, PlanView } from '@/components';

export const PlanViewPage = () => (
  <Dashboard openLogIn>
    <PlanView />
  </Dashboard>
);
